import { gsap, ScrollTrigger } from 'gsap/all';
import Player from '@vimeo/player';

gsap.registerPlugin(ScrollTrigger);

const Video = {
  init: function () {
    this.initVideoModules();
    this.initScrollTrigger();
  },

  initVideoModules: function () {
    const videoModules = document.querySelectorAll('.media-module__video');

    videoModules.forEach((module) => {
      const playButton = module.querySelector('.play-button');
      const video = module.querySelector('video');
      const preview = module.querySelector('.video-preview');
      const embedContainer = module.querySelector('.video-embed-container');
      const embed = embedContainer?.querySelector('iframe');
      let vimeoPlayer = null;

      console.log('Found elements:', {
        playButton: !!playButton,
        video: !!video,
        preview: !!preview,
        embedContainer: !!embedContainer,
        embed: !!embed,
      });

      // Initialize Vimeo player if it's a Vimeo embed
      if (embed && embed.src.includes('vimeo')) {
        vimeoPlayer = new Player(embed);
        // Initially hide the iframe until play is clicked
        embedContainer.style.display = 'none';
        console.log('Vimeo player initialized');
      }

      if (playButton) {
        playButton.addEventListener('click', () => {
          console.log('Play button clicked');
          if (video) {
            // Handle native video
            video.classList.add('playing');
            if (preview) preview.style.display = 'none';
            playButton.style.display = 'none';
            video.play();
          } else if (vimeoPlayer) {
            console.log('Handling Vimeo video');
            // Handle Vimeo embed
            if (preview) {
              console.log('Adding hidden class to preview');
              preview.classList.add('hidden');
            }
            playButton.style.display = 'none';
            embedContainer.style.display = 'block';
            vimeoPlayer
              .play()
              .then(() => {
                console.log('Vimeo video started playing');
              })
              .catch((error) => {
                console.error('Error playing Vimeo video:', error);
              });
          }
        });
      }
    });
  },

  initScrollTrigger: function () {
    const videoModules = document.querySelectorAll('.media-module__video');

    videoModules.forEach((module) => {
      const video = module.querySelector('video');
      const embedContainer = module.querySelector('.video-embed-container');
      const embed = embedContainer?.querySelector('iframe');
      let vimeoPlayer = null;

      // Initialize Vimeo player if it's a Vimeo embed
      if (embed && embed.src.includes('vimeo')) {
        vimeoPlayer = new Player(embed);
      }

      if (video || vimeoPlayer) {
        ScrollTrigger.create({
          trigger: module,
          start: 'top center',
          end: 'bottom center',
          // markers: true,
          onLeave: () => {
            // Only pause when scrolling away
            if (video && video.classList.contains('playing')) {
              video.pause();
            } else if (vimeoPlayer && embedContainer.style.display !== 'none') {
              vimeoPlayer.pause();
            }
          },
          onLeaveBack: () => {
            // Only pause when scrolling away
            if (video && video.classList.contains('playing')) {
              video.pause();
            } else if (vimeoPlayer && embedContainer.style.display !== 'none') {
              vimeoPlayer.pause();
            }
          },
        });
      }
    });
  },
};

export default Video;
